import _regeneratorRuntime from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '@/assets/images/login/google.png';
var _hoisted_1 = {
  class: "google-sign-in-btn-container"
};
var _hoisted_2 = ["id"];
import googleSignInHelper from "@/utils/googleSignInHelper";
import { checkIfInAppWebview } from "@/utils/tools";
import { onMounted } from "vue";
import Dialog from "@/components/dialog/dialog";
export default {
  __name: 'GoogleSignInButton',
  props: {
    id: {
      type: String,
      required: true
    }
  },
  emits: ["success"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var isInWebview = checkIfInAppWebview();
    var emit = __emit;
    var props = __props;
    function renderButton() {
      return _renderButton.apply(this, arguments);
    }
    function _renderButton() {
      _renderButton = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return googleSignInHelper.init({
                clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
                callback: function callback(response) {
                  emit("success", {
                    token: response.credential
                  });
                }
              });
            case 2:
              googleSignInHelper.renderButton(props.id);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _renderButton.apply(this, arguments);
    }
    var showGoogleSignInDialog = function showGoogleSignInDialog() {
      Dialog.confirm({
        title: "Cannot continue with Google",
        desc: "Please open this page in your browser to log in",
        okText: "Got it",
        withoutCancel: true
      });
    };
    onMounted(function () {
      renderButton();
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(isInWebview) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "google-btn-tip",
        onClick: showGoogleSignInDialog
      }, [_cache[0] || (_cache[0] = _createElementVNode("img", {
        class: "button-wrap-icon",
        src: _imports_0
      }, null, -1)), _createTextVNode(_toDisplayString(_ctx.$t("continueWithGoogle")), 1)])) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        id: __props.id,
        class: "google-sign-in-btn"
      }, null, 8, _hoisted_2))]);
    };
  }
};